import { CloseIcon } from "../../icons";
import MonfiMarkIcon from "../../icons/MonfiMarkIcon";

const GuideHint = ({
  title,
  description,
  position = "left",
  showPointer = false,
  primaryAction,
  secondaryAction = "skip",
  onSkip,
  onDone,
  onBuyCrypto,
  onDepositCrypto,
}) => {
  const secondaryLabels = {
    buyCrypto: "Buy Crypto",
    depositCrypto: "Deposit Crypto",
    skip: "Skip",
  };
  const secondaryLabel = secondaryLabels[secondaryAction] ?? "Skip";
  const showPrimary = primaryAction === "done";

  const hideHints = (event) => {
    event.stopPropagation();
    onSkip?.();
  };

  const handleSecondary = (event) => {
    if (secondaryAction === "buyCrypto") {
      onBuyCrypto?.();
      return;
    }
    if (secondaryAction === "depositCrypto") {
      onDepositCrypto?.();
      return;
    }
    hideHints(event);
  };

  return (
    <div className="relative sm:w-full" onMouseDown={(event) => event.stopPropagation()}>
      {showPointer && position === "right" && (
        <span
          className="absolute left-0 top-1/2 hidden size-0 -translate-x-full -translate-y-1/2 border-y-[10px] border-r-[12px] border-y-transparent border-r-[#EAF8E8] lg:block"
          aria-hidden
        />
      )}
      {showPointer && position === "left" && (
        <span
          className="absolute right-0 top-1/2 hidden size-0 translate-x-full -translate-y-1/2 border-y-[10px] border-l-[12px] border-y-transparent border-l-[#EAF8E8] lg:block"
          aria-hidden
        />
      )}

      <div className="relative overflow-visible rounded-[16px] bg-[#E9FFE4] px-5 py-5 shadow-[0_4px_24px_rgba(0,0,0,0.12)] sm:pl-[32px]">
        <div className="absolute left-0 top-1 z-10 flex size-[45px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-[0_4px_16px_rgba(0,0,0,0.08)]">
          <MonfiMarkIcon className="h-[25px] w-[25px]" />
        </div>

        <button
          type="button"
          onClick={hideHints}
          className="absolute right-3 top-3 rounded-full p-0 custom-transition hover:bg-white/60"
          aria-label="Close hint"
        >
          <CloseIcon className="text-[#777]" />
        </button>

        <h3 className="pr-6 text-[16px] font-outfit font-semibold leading-[22px] text-[#111]">{title}</h3>
        <p className="mt-2 text-xs font-outfit text-[#777]">{description}</p>

        <div
          className={`mt-5 flex items-center gap-3 ${
            showPrimary ? "justify-between" : "justify-start"
          }`}
        >
          <button
            type="button"
            onClick={handleSecondary}
            className="text-sm font-semibold font-outfit text-primary-300 custom-transition hover:opacity-80"
          >
            {secondaryLabel}
          </button>
          {showPrimary && (
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onDone?.();
              }}
              className="rounded-[8px] bg-[#4AB933] font-outfit font-medium px-4 py-[7px] text-sm text-white custom-transition hover:opacity-90"
            >
              Done
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GuideHint;
